import httpRequests from "@httpServices"
import { buildUrl } from "@utils/helpers"
import { BroadcastAuth } from "@/types"
import { MediaSource } from "@/types/common"
import {
  CatalogListWithPagination,
  CatalogWithPagination,
  Tag,
  Maker,
  Category,
  DetailedProduct,
  PrinterInfo,
  CatalogProduct,
  SignageContext,
} from "@/types/signage"
import { ChannelAuthorizationData } from "pusher-js/types/src/core/auth/options"

const getAdvertisementMediasUrl = "signage/advertisement-media"
const getTopPageProductGroupsUrl = "signage/products/top"
const getSignageProductsUrl = "signage/products/search"
const getSignageCategoriesUrl = "signage/categories"
const getSignageTagsUrl = "signage/tags"
const getSignageMakersUrl = "signage/makers"
const getProductDetailUrl = "signage/products/{productId}"
const getRelatedProductsUrl = "signage/products/{productId}/related"
const getPrinterInfoUrl = "signage/printer"
const getSignageContextUrl = "signage/context"
const authSignageChannelUrl = "broadcasting/signage-auth"

export function getSignageAdvertisementMedia() {
  return httpRequests.get<MediaSource[]>(buildUrl(getAdvertisementMediasUrl, {}))
}

export function getSignageTopPageCatalogues(params?: { cursor?: string | null }) {
  return httpRequests.get<CatalogListWithPagination>(buildUrl(getTopPageProductGroupsUrl, {}), {
    ...(params || {}),
    limit: 20,
  })
}

type GetProductsParams = {
  makerId?: number
  categoryId?: number
  tagId?: number
  cursor?: string | null
  perPage?: number
}

export function getSignageProducts(params?: GetProductsParams) {
  return httpRequests.get<CatalogWithPagination, GetProductsParams>(buildUrl(getSignageProductsUrl, {}), {
    ...params,
  })
}

export function getSignageCategories() {
  return httpRequests.get<Category[]>(buildUrl(getSignageCategoriesUrl, {}))
}

export function getSignageTags() {
  return httpRequests.get<Tag[]>(buildUrl(getSignageTagsUrl, {}))
}

export function getSignageMakers() {
  return httpRequests.get<Maker[]>(buildUrl(getSignageMakersUrl, {}))
}

export function getDetailedProduct(productId: number) {
  return httpRequests.get<DetailedProduct>(buildUrl(getProductDetailUrl, { productId }))
}

export function getRelatedProducts(productId: number) {
  return httpRequests.get<CatalogProduct[]>(buildUrl(getRelatedProductsUrl, { productId }))
}

export function getPrinterInfo() {
  return httpRequests.get<PrinterInfo>(buildUrl(getPrinterInfoUrl, {}))
}

export function getSignageContext() {
  return httpRequests.get<SignageContext>(buildUrl(getSignageContextUrl, {}))
}

export function authSignageChannel(body: BroadcastAuth) {
  return httpRequests.post<ChannelAuthorizationData>(authSignageChannelUrl, body)
}
